import React from "react";
import { trimOverlengthString } from "./CellText";
import { TextWrap, TextWrapUnread } from "../../utils/common";

const UnreadText = (props) => {
    return (
        <div className="flex justify-between">
            {props.isUnread ? (
                <TextWrapUnread>
                    {trimOverlengthString(props.text, props.width)}
                </TextWrapUnread>
            ) : (
                <TextWrap>
                    {trimOverlengthString(props.text, props.width)}
                </TextWrap>
            )}

            {props.icon}
        </div>
    );
};

export default UnreadText;
